export default "__VITE_ASSET__CNNCUtBa__"